import { useEffect } from 'react';
import type { FC } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Button, Drawer, Hidden } from '@material-ui/core';
import Logo from './Logo';

interface MainSidebarProps {
  onMobileClose: () => void;
  openMobile: boolean;
}

const MainSidebar: FC<MainSidebarProps> = (props) => {
  const { onMobileClose, openMobile } = props;
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  return (
    <Hidden lgUp>
      <Drawer
        anchor="left"
        onClose={onMobileClose}
        open={openMobile}
        variant="temporary"
        PaperProps={{
          sx: {
            backgroundColor: 'background.default',
            width: 256,
          },
        }}
      >
        <Box
          sx={{
            alignItems: 'flex-start',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            p: 2,
          }}
        >
          <RouterLink to="/">
            <Logo sx={{ ml: 1 }} />
          </RouterLink>
          <Button href="/#what" component="a" sx={{ textAlign: 'left' }}>
            Qué hacemos
          </Button>
          <Button href="/#video" component="a" sx={{ textAlign: 'left' }}>
            Así funcionamos
          </Button>
          <Button href="/#how" component="a" sx={{ textAlign: 'left' }}>
            Cómo lo hacemos
          </Button>
          <Button href="/#advantage" component="a" sx={{ textAlign: 'left' }}>
            Ventajas competitivas
          </Button>
          <Button href="/#benefit" component="a" sx={{ textAlign: 'left' }}>
            Beneficios
          </Button>
          <Button href="/#contact" component="a" sx={{ textAlign: 'left' }}>
            Contacto
          </Button>
          <Button href="/#contact" component="a" sx={{ textAlign: 'left' }}>
            Proveedores
          </Button>
          <Button
            sx={{
              backgroundColor: '#FCBE00',
              textAlign: 'left',
              minWidth: '117px',
              '&:hover': {
                backgroundColor: '#fbd972',
              },
            }}
            component="a"
            href="/authentication/login"
            variant="contained"
          >
            Iniciar sesión
          </Button>
        </Box>
      </Drawer>
    </Hidden>
  );
};

MainSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default MainSidebar;
